import angular from 'angular';
import ListingComponent from './components/listing';
import AddComponent from './components/add';
import EditComponent from './components/edit';
import {CouponConfig} from './components/coupon.config';
import uiRouter from 'angular-ui-router';
import Coupons from './services/coupon.service';
import CouponsDataProvider from './services/coupon.dataprovider.service';

export default angular.module('coupons', [uiRouter])
  .component('couponsListing', ListingComponent)
  .component('couponsAdd', AddComponent)
  .component('couponsEdit', EditComponent)
  .service('Coupons', Coupons)
  .service('CouponsDataProvider', CouponsDataProvider)
  .config(CouponConfig)
  .name


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/coupons/index.js
 **/